import React, { Component } from 'react';
import { Container, Row, Col, } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { NavMenuNoLogo } from './NavMenuNoLogo';
import { SideBar } from './SideBar';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import AuthFunctions from './services/AuthService';
import Session from './auth/Session';
import {withRouter, useLocation } from 'react-router-dom';
import { Route, Redirect } from 'react-router';
import LocationComponent from './util/locationComponent'


class AppBodyDefault extends Component {
    static displayName = AppBodyDefault.name;

    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
            isAuthenticated: false,
            userName: null
        };
    }
    componentDidMount() {
        //this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        //authService.unsubscribe(this._subscription);
    }

    async populateState() {
        //const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        const isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        const userName = Session.getUserName();
        this.setState({
            isAuthenticated,
            userName: userName
        });
    }

    render() {
        const { isAuthenticated, userName } = this.state;
        var currentUrl = window.location.href;
        var myProps = this.props.location;
        if (!isAuthenticated || myProps.pathname.includes("/admin/Client") || currentUrl.includes("/admin/Client") || myProps.pathname === "/") {
            const registerPath = `${ApplicationPaths.BaseIdentityRegisterPath}`;
            //const loginPath = `${ApplicationPaths.Login}`;
            const loginPath = `/login`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            //const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            const logoutPath = { pathname: `/logout`, state: { local: true } };
            return this.authenticatedView(userName, profilePath, logoutPath);
        }
    }

    authenticatedView(userName, profilePath, logoutPath) {
        return (
            <div className="g-light-gray-c flexRootContainer">
                <NavMenu anonymousView={false} />
                <div id="body">
                    <Row className="sidebarRow" >
                        <Col lg="3" xs="3" style={{ 'maxWidth': '280px' }}>
                            <div>
                                <SideBar />
                            </div>

                        </Col>
                        <Col className="g-logo-bg g-light-gray-c noMaxWidth" xs="9">
                            <div>
                                <Container className="noMaxWidth">
                                    {this.props.children}
                                </Container>
                            </div>

                        </Col>
                    </Row>
                </div>

            </div>
        );
    }

    anonymousView(registerPath, loginPath) {
        return (
            <div>
                <NavMenuNoLogo anonymousView={true}/>
                <div id="body">
                    <Row>
                        <Col>
                            <div>
                                <Container>
                                    {this.props.children}
                                </Container>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

}

export const AppBody = withRouter(AppBodyDefault);